import React, { useState } from 'react'
import Typography from '@material-ui/core/Typography'
import { TFunction } from 'i18next'
import { withTranslation } from 'react-i18next'
import GateLayout from '../layouts/gateLayout'
import { styles } from '../pagesStyles/gateStyles'
import ContentContainer from './../components/contentContainer'
import BlockUserInterface from './../components/blockUserInterface'
import LoginComponent from '../components/signIn'
import SEO from '../components/seo'
import { useLocation } from '@reach/router'

interface JoinProps {
  t: TFunction
}

const GatePage = ({ t }: JoinProps) => {
  const { pathname } = useLocation()
  const [isPageLoading, setIsPageLoading] = useState(false)
  const classes = styles()

  if (isPageLoading) {
    return <BlockUserInterface />
  }

  return (
    <>
      {!isPageLoading && (
        <GateLayout>
          {/* The home page (pages/index.tsx) renders this component when the gate setting is
              on, so noindex applies only at /gate itself. */}
          <SEO
            title="Chirpyest"
            noindex={pathname.replace(/\/+$/, '') === '/gate'}
          />
          <ContentContainer>
            <div className={classes.headingTextContainer}>
              <Typography
                variant="h1"
                align="center"
                className={classes.headingText}
              >
                {t('gate.coming2021')}
              </Typography>
              <Typography
                variant="h1"
                align="center"
                className={classes.headingText}
              >
                {t('gate.nowCharterMembersOnly')}
              </Typography>
            </div>
            <LoginComponent
              setIsLoggedIn={setIsPageLoading}
              fromGatePage={true}
            />
          </ContentContainer>
        </GateLayout>
      )}
    </>
  )
}

export default withTranslation()(GatePage)
